/*!
 * ETAR theme v4.2.4 — Header: the scent counter
 * Developed by FACTICIED · https://www.facticied.com
 * Products in menus are fetched only when a menu opens, so the header itself stays tiny.
 */
(() => {
  if (customElements.get('et-header')) return;
  const mqDesk = window.matchMedia('(min-width: 990px)');
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  class EtHeader extends HTMLElement {
    connectedCallback() {
      if (this._on) return; this._on = true;
      this.ac = new AbortController();
      const o = { signal: this.ac.signal };
      this.section = this.closest('.shopify-section');
      this.drop = this.querySelector('[data-drop]');
      this.veil = this.querySelector('[data-veil]');
      this.items = Array.from(this.querySelectorAll('[data-item]'));
      this.menu();
      this.sticky(o);
      this.search(o);
      this.drawer(o);
      this.words();
      document.addEventListener('et:cart:updated', (e) => this.count(e.detail && e.detail.item_count), o);
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { this.closePanel(); this.closeSearch(); this.closeDrawer(); } }, o);
      this.veil?.addEventListener('click', () => { this.closePanel(); this.closeSearch(); }, o);
      window.addEventListener('resize', () => this.placeDrop(this.dropOn), o);
      if (window.Shopify && Shopify.designMode) document.addEventListener('shopify:section:unload', () => this.ac.abort(), o);
      requestAnimationFrame(() => this.placeDrop(this.current()));
    }
    disconnectedCallback() { this.ac?.abort(); clearInterval(this.wt); }

    /* ---------- desktop menu ---------- */
    menu() {
      const o = { signal: this.ac.signal };
      this.items.forEach((li) => {
        const link = li.querySelector('[data-link]'), panel = li.querySelector('[data-panel]');
        li.addEventListener('pointerenter', (e) => {
          if (e.pointerType === 'touch' || !mqDesk.matches) return;
          this.placeDrop(link);
          clearTimeout(this.tClose);
          clearTimeout(this.tOpen);
          if (panel) this.tOpen = setTimeout(() => this.openPanel(li), this.openLi ? 0 : 90);
          else if (this.openLi) this.closePanel();
        }, o);
        li.addEventListener('pointerleave', (e) => {
          if (e.pointerType === 'touch') return;
          clearTimeout(this.tOpen);
          this.tClose = setTimeout(() => { this.closePanel(); this.placeDrop(this.current()); }, 180);
        }, o);
        link.addEventListener('focus', () => { this.placeDrop(link); if (panel) this.openPanel(li); else this.closePanel(); }, o);
        /* first tap on a touch screen opens the panel, second tap follows the link */
        if (panel) link.addEventListener('click', (e) => { if (mqDesk.matches && this.openLi !== li && matchMedia('(hover: none)').matches) { e.preventDefault(); this.openPanel(li); } }, o);
        if (!panel) return;
        panel.addEventListener('focusout', (e) => { if (!li.contains(e.relatedTarget)) { this.closePanel(); } }, o);
        panel.querySelectorAll('[data-handle]').forEach((a) => {
          if (a.hasAttribute('data-prods')) return;
          const show = () => { panel.querySelectorAll('.et-h__sub').forEach((x) => x.classList.toggle('is-on', x === a)); this.fill(panel.querySelector('[data-prods]'), a.dataset.handle); };
          a.addEventListener('pointerenter', show, o); a.addEventListener('focus', show, o);
        });
      });
      this.querySelector('.et-h__nav')?.addEventListener('pointerleave', () => { if (!this.openLi) this.placeDrop(this.current()); }, o);
    }
    current() { return this.querySelector('.et-h__link[aria-current="page"]'); }
    placeDrop(link) {
      if (!this.drop) return;
      this.dropOn = link;
      if (!link || !mqDesk.matches) { this.drop.classList.remove('is-on'); return; }
      const nav = (this.drop.offsetParent || this).getBoundingClientRect(), r = link.querySelector('span')?.getBoundingClientRect() || link.getBoundingClientRect();
      const line = this.classList.contains('et-hd--ind-line');
      this.drop.style.setProperty('--x', (line ? r.left - nav.left : r.left - nav.left + r.width / 2 - 3.5) + 'px');
      this.drop.style.setProperty('--w', r.width + 'px');
      this.drop.classList.add('is-on');
    }
    openPanel(li) {
      if (this.openLi === li) return;
      this.closeSearch();
      const prev = this.openLi;
      if (prev) this.hidePanel(prev, true);
      this.openLi = li;
      const p = li.querySelector('[data-panel]'), link = li.querySelector('[data-link]');
      p.hidden = false; li.classList.add('is-open'); link.setAttribute('aria-expanded', 'true');
      /* switching between menus: no pour, just swap */
      if (prev) { p.style.transition = 'none'; p.classList.add('is-open'); p.offsetHeight; p.style.transition = ''; }
      else requestAnimationFrame(() => requestAnimationFrame(() => p.classList.add('is-open')));
      const box = p.querySelector('[data-prods]'); if (box) this.fill(box, box.dataset.handle);
      p.querySelectorAll('.et-h__sub.is-on').forEach((x) => x.classList.remove('is-on'));
      this.showVeil(true);
    }
    hidePanel(li, instant) {
      const p = li.querySelector('[data-panel]'), link = li.querySelector('[data-link]');
      li.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false');
      p.classList.remove('is-open');
      if (instant) { p.hidden = true; return; }
      setTimeout(() => { if (!p.classList.contains('is-open')) p.hidden = true; }, 560);
    }
    closePanel() {
      if (!this.openLi) return;
      this.hidePanel(this.openLi); this.openLi = null;
      if (!this.searchOpen) this.showVeil(false);
    }
    /* ---------- products, fetched when needed ---------- */
    money(v) {
      const f = this.dataset.money || '{{amount}}', n = Number(v);
      const g = (d, t, sp) => { const p = n.toFixed(d).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (p[1] ? sp + p[1] : ''); };
      return f.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => k === 'amount_no_decimals' ? g(0, ',', '.') : k === 'amount_with_comma_separator' ? g(2, '.', ',') : k === 'amount_no_decimals_with_comma_separator' ? g(0, '.', ',') : (Number.isInteger(n) ? g(0, ',', '.') : g(2, ',', '.')));
    }
    get(handle, n) {
      this.cache = this.cache || new Map();
      const key = handle + '|' + n;
      if (!this.cache.has(key)) {
        const root = this.dataset.root || '/';
        this.cache.set(key, fetch(`${root}collections/${encodeURIComponent(handle)}/products.json?limit=${n}`, { headers: { Accept: 'application/json' } })
          .then((r) => (r.ok ? r.json() : { products: [] })).then((d) => d.products || []).catch(() => []));
      }
      return this.cache.get(key);
    }
    async fill(box, handle) {
      if (!box || !handle || box.dataset.shown === handle) return;
      const n = parseInt(this.dataset.products, 10) || (box.classList.contains('et-h__strip') ? 6 : 0);
      if (!n) return;
      box.dataset.shown = handle;
      const lim = box.classList.contains('et-h__strip') ? 6 : n;
      const list = (await this.get(handle, lim)).slice(0, lim);
      if (box.dataset.shown !== handle) return;
      const root = this.dataset.root || '/', price = this.dataset.showPrice !== 'false';
      if (!list.length) { box.innerHTML = ''; return; }
      box.innerHTML = list.map((p, i) => {
        const img = p.images && p.images[0] ? p.images[0].src : '';
        const src = img ? img + (img.includes('?') ? '&' : '?') + 'width=500' : '';
        const v = p.variants && p.variants[0];
        return `<a class="et-h__p" style="--i:${i}" href="${root}products/${esc(p.handle)}"><span class="et-h__p-media">${src ? `<img src="${esc(src)}" alt="${esc(p.title)}" loading="lazy" width="400" height="500">` : ''}</span><span class="et-h__p-name">${esc(p.title)}</span>${price && v ? `<span class="et-h__p-price">${esc(this.money(v.price))}</span>` : ''}</a>`;
      }).join('');
    }
    showVeil(on) {
      if (!this.veil) return;
      clearTimeout(this.vt);
      if (on) { this.veil.hidden = false; requestAnimationFrame(() => this.veil.classList.add('is-on')); }
      else { this.veil.classList.remove('is-on'); this.vt = setTimeout(() => { this.veil.hidden = true; }, 450); }
    }

    /* ---------- sticky ---------- */
    sticky(o) {
      const mode = this.dataset.sticky;
      if (this.section) this.section.classList.toggle('is-sticky', mode !== 'none');
      let last = window.scrollY, ticking = false;
      /* where the header sits before it sticks (a stuck element reports its stuck position) */
      this.top0 = this.section ? this.section.getBoundingClientRect().top + window.scrollY : 0;
      window.addEventListener('resize', () => { if (window.scrollY < 5 && this.section) this.top0 = this.section.getBoundingClientRect().top; }, o);
      const run = () => {
        ticking = false;
        const y = window.scrollY, top = this.top0;
        this.classList.toggle('is-scrolled', y > top + 4);
        if ((mode === 'scroll_up' || mode === 'up') && this.section) {
          const down = y > last && y > top + this.offsetHeight + 80;
          if (!this.openLi && !this.searchOpen) this.section.classList.toggle('is-hidden', down);
        }
        last = y;
      };
      window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true, ...o });
      run();
    }

    /* ---------- search ---------- */
    words() {
      const el = this.querySelector('[data-word]'); if (!el) return;
      const w = (this.dataset.words || '').split(',').map((x) => x.trim()).filter(Boolean);
      if (!w.length) return;
      let i = 0; el.textContent = w[0];
      if (w.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.wt = setInterval(() => {
        el.classList.add('is-out');
        setTimeout(() => { i = (i + 1) % w.length; el.textContent = w[i]; el.classList.remove('is-out'); }, 350);
      }, 2400);
    }
    search(o) {
      this.sp = this.querySelector('[data-search]'); if (!this.sp) return;
      this.input = this.sp.querySelector('[data-search-input]');
      this.results = this.sp.querySelector('[data-search-results]');
      this.querySelectorAll('[data-search-open]').forEach((b) => b.addEventListener('click', () => (this.searchOpen ? this.closeSearch() : this.openSearch()), o));
      if (this.dataset.predictive === 'false') return;
      let t;
      this.input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => this.suggest(this.input.value.trim()), 220); }, o);
    }
    openSearch() {
      this.closePanel();
      this.searchOpen = true; this.sp.hidden = false;
      this.querySelectorAll('[data-search-open]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
      requestAnimationFrame(() => requestAnimationFrame(() => this.sp.classList.add('is-open')));
      setTimeout(() => this.input.focus(), 120);
      this.showVeil(true);
    }
    closeSearch() {
      if (!this.searchOpen) return;
      this.searchOpen = false; this.sp.classList.remove('is-open');
      this.querySelectorAll('[data-search-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      setTimeout(() => { if (!this.searchOpen) this.sp.hidden = true; }, 560);
      if (!this.openLi) this.showVeil(false);
    }
    async suggest(q) {
      if (q.length < 2) { this.results.innerHTML = ''; return; }
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      try {
        const r = await fetch(`${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last`);
        const d = await r.json();
        if (q !== this.input.value.trim()) return;
        const items = (d.resources && d.resources.results && d.resources.results.products) || [];
        if (!items.length) { this.results.innerHTML = `<p class="et-h__rempty">${esc(this.dataset.empty)} “${esc(q)}”</p>`; return; }
        this.results.innerHTML = `<div class="et-h__rgrid">${items.map((p) => {
          const img = p.featured_image && p.featured_image.url ? `<img src="${esc(p.featured_image.url)}${p.featured_image.url.includes('?') ? '&' : '?'}width=400" alt="" loading="lazy" width="400" height="500">` : '';
          return `<a class="et-h__ritem" href="${esc(p.url)}"><span class="et-h__ritem-media">${img}</span><span class="et-h__ritem-title">${esc(p.title)}</span><span class="et-h__ritem-price">${esc(p.price)}</span></a>`;
        }).join('')}</div><a class="et-h__all et-h__rall" href="${root}search?q=${encodeURIComponent(q)}">${esc(this.dataset.viewAll)}</a>`;
      } catch (e) {}
    }

    /* ---------- mobile drawer ---------- */
    drawer(o) {
      this.dr = this.querySelector('[data-drawer]'); if (!this.dr) return;
      this.querySelectorAll('[data-drawer-open]').forEach((b) => b.addEventListener('click', () => this.openDrawer(b), o));
      this.dr.querySelectorAll('[data-drawer-close]').forEach((b) => b.addEventListener('click', () => this.closeDrawer(), o));
      this.dr.querySelectorAll('[data-go]').forEach((b) => b.addEventListener('click', () => this.level(b.dataset.go), o));
      this.dr.querySelectorAll('[data-back]').forEach((b) => b.addEventListener('click', () => this.level(b.dataset.back, true), o));
      this.dr.querySelectorAll('[data-et-loc] select').forEach((s) => s.addEventListener('change', () => s.form.submit(), o));
      mqDesk.addEventListener('change', () => { if (mqDesk.matches) this.closeDrawer(); }, o);
    }
    level(id, back) {
      const next = this.dr.querySelector(`[data-level="${id}"]`); if (!next) return;
      const cur = this.dr.querySelector('.et-h__level.is-on');
      if (cur === next) return;
      next.hidden = false;
      next.style.transition = 'none';
      next.classList.toggle('is-past', !!back);
      next.classList.remove('is-on');
      next.offsetHeight; next.style.transition = '';
      next.classList.remove('is-past'); next.classList.add('is-on');
      if (cur) {
        cur.classList.remove('is-on');
        if (!back) cur.classList.add('is-past');
        setTimeout(() => { if (!cur.classList.contains('is-on')) { cur.hidden = true; cur.classList.remove('is-past'); } }, 520);
      }
      next.scrollTop = 0;
      if (this.dataset.drawerProducts !== 'false') { const st = next.querySelector('[data-prods]'); if (st) this.fill(st, st.dataset.handle); }
    }
    openDrawer(btn) {
      this.dbtn = btn; this.dr.hidden = false;
      requestAnimationFrame(() => requestAnimationFrame(() => this.dr.classList.add('is-open')));
      this.querySelectorAll('[data-drawer-open]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
      document.documentElement.style.overflow = 'hidden';
      this.untrap = window.Etar && Etar.trapFocus ? Etar.trapFocus(this.dr) : null;
    }
    closeDrawer() {
      if (!this.dr || !this.dr.classList.contains('is-open')) return;
      this.dr.classList.remove('is-open');
      this.querySelectorAll('[data-drawer-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      document.documentElement.style.overflow = '';
      if (this.untrap) this.untrap();
      setTimeout(() => { if (!this.dr.classList.contains('is-open')) { this.dr.hidden = true; this.level('root', true); } }, 560);
      this.dbtn?.focus();
    }

    count(n) {
      if (typeof n !== 'number') return;
      this.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = n; el.classList.toggle('is-empty', n === 0);
        el.classList.remove('is-bump'); void el.offsetWidth; if (n) el.classList.add('is-bump');
      });
    }
  }
  customElements.define('et-header', EtHeader);
})();
